import React, { useRef } from 'react';
import styled from 'styled-components';

const ImageUpload = ({ children, onChange, beforeUpload, accept = "image/*", ...props }) => {
  const inputRef = useRef();

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (beforeUpload && !beforeUpload(file)) {
        return;
      }
      onChange({ file, status: 'done' });
    }
  };

  return (
    <UploadWrapper onClick={handleClick}>
      <HiddenInput
        type="file"
        ref={inputRef}
        onChange={handleChange}
        accept={accept}
        {...props}
      />
      {children}
    </UploadWrapper>
  );
};

const UploadWrapper = styled.div`
  cursor: pointer;
`;

const HiddenInput = styled.input`
  display: none;
`;

export default ImageUpload; 